import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InsightSuggestion, PriceSuggestion } from 'app/services/agents/insights-suggestions.service';
import { IanTranslateService } from 'core/services/ian-core-singleton.service';

@Component({
  selector: 'insight-suggestion-card',
  template: `
    <div class="suggestion-card" [ngClass]="'suggestion-' + suggestion.type">
      <div class="card-header">
        <div class="suggestion-type">
          <mat-icon [ngSwitch]="suggestion.type">
            <ng-container *ngSwitchCase="'price_change'">trending_up</ng-container>
            <ng-container *ngSwitchCase="'inventory_adjustment'">inventory_2</ng-container>
            <ng-container *ngSwitchCase="'promotion_recommendation'">local_offer</ng-container>
            <ng-container *ngSwitchDefault>lightbulb</ng-container>
          </mat-icon>
          <span class="type-label">{{ getTypeLabel() }}</span>
        </div>
        <mat-chip-list>
          <mat-chip [ngClass]="getStatusClass()">
            {{ getStatusLabel() }}
          </mat-chip>
        </mat-chip-list>
      </div>

      <div class="card-content">
        <h4 class="suggestion-description">{{ suggestion.description }}</h4>
        <p class="suggestion-reason">{{ suggestion.reason }}</p>

        <!-- Detalles de sugerencias de precio -->
        <div *ngIf="suggestion.type === 'price_change' && suggestion.suggestions.length > 0" class="price-suggestions">
          <h5>{{ 'AI_CHAT.INSIGHTS.PROPOSED_CHANGES' | pTranslate }}</h5>
          <div class="price-items">
            <div *ngFor="let priceItem of suggestion.suggestions" class="price-item">
              <span class="item-info"
                >{{ 'AI_CHAT.INSIGHTS.ITEM_STORE' | pTranslate }} {{ priceItem.item_id }} - {{ 'AI_CHAT.INSIGHTS.STORE' | pTranslate }}
                {{ priceItem.store_id }}</span
              >
              <span class="new-price">{{ '$' + (priceItem.new_price | number : '1.2-2') }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="card-actions" *ngIf="suggestion.suggestion_status === 'pending_approval'">
        <button mat-button color="warn" (click)="onReject()" [disabled]="isProcessing" class="reject-btn">
          <mat-icon>close</mat-icon>
          {{ 'AI_CHAT.INSIGHTS.REJECT' | pTranslate }}
        </button>
        <button mat-raised-button color="primary" (click)="onApprove()" [disabled]="isProcessing" class="approve-btn">
          <mat-icon>check</mat-icon>
          {{ 'AI_CHAT.INSIGHTS.APPROVE' | pTranslate }}
        </button>
      </div>

      <!-- Loading overlay -->
      <div *ngIf="isProcessing" class="processing-overlay">
        <mat-spinner diameter="24"></mat-spinner>
        <span>{{ 'AI_CHAT.INSIGHTS.PROCESSING' | pTranslate }}</span>
      </div>
    </div>
  `,
  styleUrls: ['./insight-suggestion-card.component.scss'],
})
export class InsightSuggestionCardComponent {
  @Input() suggestion!: InsightSuggestion;
  @Input() isProcessing = false;

  @Output() approve = new EventEmitter<number>();
  @Output() reject = new EventEmitter<number>();

  constructor(private translate: IanTranslateService) {}

  onApprove(): void {
    if (!this.isProcessing) {
      this.approve.emit(this.suggestion.id);
    }
  }

  onReject(): void {
    if (!this.isProcessing) {
      this.reject.emit(this.suggestion.id);
    }
  }

  getTypeLabel(): string {
    const labels = {
      price_change: this.translate.instant('AI_CHAT.INSIGHTS.TYPES.PRICE_CHANGE'),
      inventory_adjustment: this.translate.instant('AI_CHAT.INSIGHTS.TYPES.INVENTORY_ADJUSTMENT'),
      promotion_recommendation: this.translate.instant('AI_CHAT.INSIGHTS.TYPES.PROMOTION_RECOMMENDATION'),
      other: this.translate.instant('AI_CHAT.INSIGHTS.TYPES.OTHER'),
    };
    return labels[this.suggestion.type] || this.translate.instant('AI_CHAT.INSIGHTS.TYPES.DEFAULT');
  }

  getStatusLabel(): string {
    const labels = {
      pending_approval: this.translate.instant('AI_CHAT.INSIGHTS.STATUS.PENDING'),
      approved: this.translate.instant('AI_CHAT.INSIGHTS.STATUS.APPROVED'),
      rejected: this.translate.instant('AI_CHAT.INSIGHTS.STATUS.REJECTED'),
      implemented: this.translate.instant('AI_CHAT.INSIGHTS.STATUS.IMPLEMENTED'),
    };
    return labels[this.suggestion.suggestion_status] || this.translate.instant('AI_CHAT.INSIGHTS.STATUS.UNKNOWN');
  }

  getStatusClass(): string {
    const classes = {
      pending_approval: 'status-pending',
      approved: 'status-approved',
      rejected: 'status-rejected',
      implemented: 'status-implemented',
    };
    return classes[this.suggestion.suggestion_status] || '';
  }
}
